import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=262f9a8f&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=262f9a8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262f9a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262f9a8f')) {
      api.createRecord('262f9a8f', component.options)
    } else {
      api.reload('262f9a8f', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=262f9a8f&scoped=true&", function () {
      api.rerender('262f9a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z6ChLCLie0Mq/JS/comp/GuestBoxKids.vue"
export default component.exports